export enum PlotType {
    Histogram = "histogram",
    BarChart = "barchart",
    Scatter = "scatter",
    ScatterWithColorMapping = "scatterWithColor",
}
export enum BarSortBy {
    Value = "value",
    Key = "key",
}
